/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod'

import { type CTAStyling, CTAStylingSchema } from '../shared/cta-styling'
import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type Image, ImageSchema } from './image'
import type { RichText } from './rich-text'

/* TypeScript */
export type SliderSlide = {
  id: string
  technicalName?: string
  image: Image
  link?: Maybe<ContentLink>
  linkLabel?: string
  title?: RichText
  fontType?: 'Ivar' | 'Duplet'
  titleFontSize?: 'S' | 'M' | 'L'
  alignment?: 'Left' | 'Center'
  subtitle?: RichText
  ctaStyling?: CTAStyling
}

export type SliderApiProps = {
  technicalName?: string
  slides: SliderSlide[]
  isFullWidth?: boolean
}

/* Schemas */
export const SliderSlideSchema = z.object({
  id: z.string(),
  technicalName: z.string().optional(),
  image: ImageSchema,
  link: ContentLinkSchema.optional().nullable(),
  linkLabel: z.string().optional(),
  title: LooseRichTextSchema.optional(),
  fontType: z.enum(['Ivar', 'Duplet']).optional(),
  titleFontSize: z.enum(['S', 'M', 'L']).optional(),
  alignment: z.enum(['Left', 'Center']).optional(),
  subtitle: LooseRichTextSchema.optional(),
  ctaStyling: CTAStylingSchema.optional(),
})

export const SliderApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  slides: z.array(SliderSlideSchema),
  isFullWidth: z.boolean().optional(),
})

/* Schemas validation */
type TestSliderProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<SliderApiProps>,
    z.infer<typeof SliderApiPropsSchema>
  >
>
